import axios from "axios";
const logoData = {
  data() {
    return {
      productData: {
        newProduct: "",
        product: ""
      },
      bol: false
    };
  },
  methods: {
    getProductName() {
    this.bol = true;
      axios.get("./static/product_name.json").then(res => {
        this.productData = res.data;
      });
    }
  },
  created() {
    if (!this.bol) {
      this.getProductName();
    }
  }
};

export default logoData;
